import { render } from "./App.vue?vue&type=template&id=e67af61a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e67af61a&scoped=true&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.0+webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67af61a"]])

export default __exports__